<template>
  <div>
    <div v-if="this.serviceTypes.length === 1">
      <component :is="serviceTypes[0]"
                 @form-state="setServiceValidity"
                 @form-invalid="setServiceValidity(false)"
                 @form-valid="setServiceValidity(true)"
      ></component>
    </div>
    <div v-else>
      <!-- todo -->
    </div>
  </div>
</template>

<script>
import residentialConnection from "../Services/create/ResidentialConnection.vue";
import Vue from "vue";
import logger from "../../lib/logger";

export default {
  name: "AddServices",
  components:{
    residentialConnection,
  },

  props:{
    serviceTypes: {type: Array, default: ()=>{return []}, required: false},
  },

  data () {
    return {
      services: [],
      servicesValid: false,
    }
  },

  computed : {
    servicesAreValid () {
      return this.servicesValid;
    },
  },

  methods:{
    setServiceValidity(value) {
      this.servicesValid = value;
    },
  },

  watch:{
    servicesAreValid: {
      handler(newv, oldv) {
        logger.debug('services are valid: ', newv);
        this.$emit(newv ? 'form-valid' : 'form-invalid');
        this.$emit('form-state', newv);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddServices.vue?1ebfad21